/**
 * Take a string and character limit, and truncates string without cutting words
 * Don't count spaces (word delimiters) in the character count, and preserve HTML integrity if there is markup
 *
 * Regex for CN / JP word separators
 * \uFF0C - Fullwidth comma ( chinese word separator )
 * \u3001 - Ideographic Comma ( japanese word separator )
 */
export const truncateStringToNearestWord = (string: string, charLimit: number) => {
    const chars = string.trim().split('');
    const truncatedString = [];

    let count = 0;
    let startCount = true;
    let isMidWord = true;
    let locationOfLastSpace = 0;
    const wordDelimiterRegEx = /\uFF0C|\u3001|\s/;

    for (let i = 0; i < chars.length; i++) {
        const char = string[i];
        //I've encountered the start of an html tag, stop counting!
        if (char === '<') {
            startCount = false;
        }

        // Need to keep track the location of last space in case we need to prevent word breask
        if (wordDelimiterRegEx.test(char)) {
            locationOfLastSpace = i;
        }

        // If I'm counting and haven't reached a whitespace character, then keep going
        if (startCount && !wordDelimiterRegEx.test(char)) {
            count++;
        }

        //I've come to the end of my html tag, proceed counting characters
        if (char === '>' && !startCount) {
            startCount = true;
        }

        if (count <= charLimit) {
            truncatedString.push(char);

            // if last pushed character was a space, that means we're at the end of the word
            isMidWord = !wordDelimiterRegEx.test(char);
        } else {
            break;
        }
    }
    const rawTruncatedString = isMidWord
        ? truncatedString.slice(0, locationOfLastSpace).join('').trim()
        : truncatedString.join('').trim();

    // parse string to make sure we don't break any HTML tags before returning
    return new DOMParser().parseFromString(rawTruncatedString, 'text/html').body.innerHTML;
};
